<template>
  <Loader v-if="showLoader"/>
  <div class="container" v-show="!showLoader">
    <ClientOnly>
      <Header/>
    </ClientOnly>
    <div class="content">
      <slot/>
    </div>
  </div>
</template>
<script setup lang="ts">
import Header from "~/components/ui/Header.vue";
import Loader from "~/components/Loader.vue";
import {useFMStore} from "~/store/FMStore";
import {ref, watch} from "vue";

const FMStore = useFMStore();
const showLoader = ref(true);
let timeoutId = null;

watch(
    () => FMStore.loading,
    (newValue) => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      if (newValue) {
        showLoader.value = true;
      } else {
        timeoutId = setTimeout(() => {
          showLoader.value = false;
        }, 500);
      }
    },
    {immediate: true}
);
</script>
<style lang="scss">
.container {
  height: 100dvh;
  width: 100%;
  max-width: 768px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  background-color: white;

  .content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    & > div {
      flex-grow: 1;
    }
  }


}
</style>
